import { render, staticRenderFns } from "./MenuDevis.vue?vue&type=template&id=1585bf1a&scoped=true&"
import script from "./MenuDevis.vue?vue&type=script&lang=js&"
export * from "./MenuDevis.vue?vue&type=script&lang=js&"
import style0 from "./MenuDevis.vue?vue&type=style&index=0&id=1585bf1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1585bf1a",
  null
  
)

export default component.exports